export const ratings = [
  { star: "5 STAR", width: "20%", percentage: 20 },
  { star: "4 STAR", width: "20%", percentage: 20 },
  { star: "3 STAR", width: "40%", percentage: 40 },
  { star: "2 STAR", width: "18%", percentage: 18 },
  { star: "1 STAR", width: "2%", percentage: 2 },
];
